import React, { useContext, createContext, MutableRefObject } from 'react'


type MessageLayerContext = {
  widgetRef: MutableRefObject<HTMLIFrameElement | null>
}

const Context = createContext<MessageLayerContext | undefined>(undefined)


type Props = {
  widgetRef: MutableRefObject<HTMLIFrameElement | null>
  children: React.ReactNode
}
const Provider = ({ widgetRef, children }: Props) => (
  <Context.Provider value={{widgetRef}}>
    {children}
  </Context.Provider>
)


export const useMessageLayerContext = () => {
  const context = useContext(Context)

  if (context === undefined) {
    throw new Error('Unexpected context error (Messages)')
  }

  return context
}

export default Provider
